import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const savePayroll = async (input) => {
  
  const { data } = await http_payroll.post(
    Api_EndPoints.SavePayroll,
    input
  );
  return data;
};

export const useSavePayrollMutation = () => {
  return useMutation({
    mutationFn: savePayroll,
  });
};
